import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderBase } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-base';

@Component({
    selector: 'fi-news-feed-item-header-baloo',
    templateUrl: './news-feed-item-header-baloo.component.html',
    styleUrls: ['./news-feed-item-header-baloo.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-item-header-baloo' },
    standalone: false,
})
export class NewsFeedItemHeaderBalooComponent extends NewsFeedItemHeaderBase {}
